import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as api from './api';
import { createWithInitialState } from './store';
import { Provider } from 'react-redux';

const store = createWithInitialState({
  profiles: api.getProfiles(),
  currentProfileId: api.getCurrentProfileId(),
  catalog: api.getCatalog(),
  lists: api.getLists(),
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
